import type { JSX } from 'react';

import { Helmet } from 'react-helmet-async';

export function PageMeta(): JSX.Element {
	// const { translate } = useI18n();
	// const title = translate('corgi.topic_page_sitemap.meta.title');
	// const description = translate('corgi.topic_page_sitemap.meta.description');

	const title = 'Browse by Topic';
	const description =
		'Discover petitions on the issues you care about. Support causes that matter and drive change on Change.org.';
	const canonicalUrl = 'https://www.change.org/topic';

	return (
		<Helmet>
			<link rel="canonical" href={canonicalUrl}></link>
			<title>{title}</title>
			<meta property="title" content={title} />
			<meta name="description" content={description} />
			<meta property="og:url" content={canonicalUrl} />
			<meta property="og:title" content={title} />
			<meta property="twitter:image:alt" content={title} />
			<meta property="og:type" content="website" />
		</Helmet>
	);
}
